import React, { useState } from "react";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Logo from "../../assets/images/logo.svg";
import Menu from "../../Components/Menu";
import Button from "../../Components/Button";
import QRCode from "../../assets/images/qr_code.png";
import MenuMobile from "../../Components/MenuMobile";

const Header = () => {
  const [showQRCode, setShowQRCode] = useState(true);

  const redirect = () => {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = "/redirect";
    } else {
      // setShowQRCode(!showQRCode);
    }
  };

  return (
    <Container style={{ marginBottom: window.innerWidth > 576 ? "60px" : 0 }}>
      <Row
        xs="100%"
        sm="120px auto 144px"
        md="140px auto 144px"
        lg="160px auto 144px"
        xl="180px auto 144px"
        style={{ marginTop: "60px", alignItems: "center" }}
      >
        <img
          src={Logo}
          alt="logo"
          width={"100%"}
          height={"60px"}
          // style={{ marginTop: "-30px" }}
        />
        {window.innerWidth > 567 ? <Menu /> : <MenuMobile />}
        {window.innerWidth > 576 && (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <>
              <Button
                onClick={() => {
                  redirect();
                }}
              >
                Começar agora
              </Button>
              {showQRCode && (
                <img
                  src={QRCode}
                  width={"144px"}
                  style={{
                    position: "absolute",
                    top: "58px",
                    margin: "auto",
                    border: "4px solid #4162fd",
                    borderRadius: "8px",
                  }}
                />
              )}
            </>
          </div>
        )}
      </Row>
    </Container>
  );
};

export default Header;
